var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"warning mb-4",attrs:{"block":""},on:{"click":function($event){return _vm.onClick()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("check")]),_c('span',{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.label))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }